import { BaseLookupModel, PaginationFilterRequest } from "./core.model";

export interface Story {
  id: number;
  name: string;
  description: string;
  bannerUrl: string;
  badgeIconUrl: string;
  status: StoryStatusEnum;
  cityId?: number;
  countryId?: number;
  isCharity: boolean;
  goldLevelAmount: number;  
  silverLevelAmount: number;  
  bronzeLevelAmount: number;  
}
export interface StoryList {
  id: number;
  name: string;
  description: string;
  bannerUrl: string;
  badgeIconUrl: string;
  status: StoryStatusEnum;
  cityId: number;
  countryId: number;
  city?: BaseLookupModel;
  country?: BaseLookupModel;
  isCharity: boolean;
  goldLevelAmount: number;  
  silverLevelAmount: number;  
  bronzeLevelAmount: number;  
}


export interface UpsertStory {
  id?: number;
  name?: string;
  description?: string;
  bannerUrl?: string;
  badgeIconUrl?: string;
  status?: StoryStatusEnum;
  cityId?: number;
  countryId?: number;
  isCharity?: boolean;
  goldLevelAmount?: number;  
  silverLevelAmount?: number;  
  bronzeLevelAmount?: number;  
}

export class StoryPaginationFilterRequest extends PaginationFilterRequest{  
  cityId?: number;
  countryId?: number;
  status?: StoryStatusEnum;
  onlyCharities?: boolean;
}


export enum StoryStatusEnum {
    Draft = 0,
    Active = 1,
    BetaUserAccess = 2,
}
export const StoryStatusList = [
    {value: 0, label: "Draft"},
    {value: 1, label: "Active"},
    {value: 2, label: "Beta User Access"},
];